import { render } from "./AddUserContainer.vue?vue&type=template&id=6778925d"
import script from "./AddUserContainer.vue?vue&type=script&lang=js"
export * from "./AddUserContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__